// extracted by mini-css-extract-plugin
export var checkbox = "_3t-0";
export var circle = "_3t-3";
export var horizontalContainer = "_3t-7";
export var sm = "_3t-5";
export var switch0 = "_3t-2";
export var switchDisabled = "_3t-8";
export var switchEnabled = "_3t-1";
export var textSwitchContainer = "_3t-9";
export var textSwitchOption = "_3t-a";
export var textSwitchOptionSelected = "_3t-b";
export var verticalContainer = "_3t-6";
export var xs = "_3t-4";